import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import { addFrontEndUser, userEdited } from '../../actions/frontEndUser';
import { Button, Form, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle } from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import {addReportType} from '../../actions/report';
class ReportForm extends Component {

    constructor(props,context) {
        super(props,context);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {reportData: false, edit: false}
        this.handleChange = this.handleChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.setCheckedValue = this.setCheckedValue.bind(this);
    }

    componentWillMount()
    {
        if(this.props.match.params.reportId)
        {
            const reportId = this.props.match.params.reportId;
            const reportType = this.props.reportData.data.find(e => e.id === reportId);
            const index = this.props.reportData.data.findIndex(e => e.id === reportId);
            
            this.setState({
                reportData : {
                    name: reportType.name,
                    is_global: reportType.is_global,
                    is_active: reportType.is_active
                },
                id: reportType.id,
                index: index,
                selectedFileType: reportType.selectedFileType,
                selectedAddresses: reportType.selectedAddresses,
                edit: true
            })            
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.addReportType(this.props.clientPath.clientPath, this.state);
    }

    setInputState(e) {
      this.setState({
          reportData: {...this.state.postData, [e.target.name]: e.target.value }
      });
    }

    handleChange(selectedOption) {

        this.setState({ selectedFileType: selectedOption });
    }

    handleAddressChange(selectedOption) {
        this.setState({ selectedAddresses: selectedOption });
    }
    mapFileTypes(val, key) {
         return { value: val.id, label: val.type }
    }

    mapAddresses(address, key) {
        return { value: address.dp_address_id, label: address.street+' '+address.zipcode+' '+address.city }
    }

    setCheckedValue(e) {
        this.setState({
            reportData: {...this.state.reportData, [e.target.name]: e.target.checked ? 1 : 0 }
        })
    }

    render() {
   
        return (
            <div className="animated fadeIn">
             <Card>
                <CardBody>
                    <CardTitle><i className="fa fa-user"></i> Bestandstype rapportage {this.state.edit ? 'bewerken' : 'toevoegen'}</CardTitle>
                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                        <FormGroup>
                            <Label for="name">Naam</Label>
                            <Input type="text" defaultValue={this.state.reportData ? this.state.reportData.name : ''} onChange={(e) => this.setInputState(e)} name="name" id="name" placeholder="Naam" />
                        </FormGroup>
                        <FormGroup>
                            <Label  for="product_id">Bestandstype</Label>
                            {this.props.fileTypeData.data ?
                               <Select
                                    name="metadata_category_id"
                                    simpleValue={true}
                                    value={this.state.selectedFileType}
                                    onChange={this.handleChange}
                                    options={ this.props.fileTypeData.data.map((filetype, key) => this.mapFileTypes(filetype, key))}
                                  />
                              : null}
                        </FormGroup>
                        {this.state.reportData.is_global == '1' ? '' : 
                        <FormGroup>
                            <Label  for="product_id">Beschikbaar voor adressen</Label>
                            {this.props.clientData.allAddresses ?
                               <Select
                                    name="address_id"
                                    simpleValue={true}
                                    multi={true}
                                    value={this.state.selectedAddresses}
                                    onChange={this.handleAddressChange}
                                    options={this.props.clientData.allAddresses ? this.props.clientData.allAddresses.map((val, key) => this.mapAddresses(val, key)): null}
                                  />
                              : null}
                        </FormGroup> }
                        {this.state.selectedAddresses && this.state.selectedAddresses != '' ? '' :
                         <FormGroup check>
                            <Label check for="is_global">
                                <Input type="checkbox" defaultChecked={this.state.reportData && this.state.reportData.is_global === '1' ? 'checked' : ''} onChange={(e) => this.setCheckedValue(e)} name="is_global" id="is_global" />
                                Is een globale rapportage?
                            </Label>
                        </FormGroup>}
                        <FormGroup check>
                            <Label check for="is_active">
                                <Input type="checkbox" defaultChecked={this.state.reportData && this.state.reportData.is_active === '1' ? 'checked' : ''} onChange={(e) => this.setCheckedValue(e)} name="is_active" id="is_active" />
                                Is actief?
                            </Label>
                        </FormGroup>             
                        <button type="submit" className="btn btn-sm btn-primary">
                            <i className="fa fa-dot-circle-o"></i> {this.state.edit ? 'Bijwerken' : 'Toevoegen'}
                        </button>
                    </Form>
                </CardBody>

            </Card>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        frontEndUserData: state.FrontEndUserReducer,
        fileTypeData: state.FileTypeDataReducer,
        clientPath: state.clientPathReducer,
        clientData: state.ClientDataReducer,
        reportData : state.ReportReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFrontEndUser: (url, postData, attached_addresses) => dispatch(addFrontEndUser(url, postData, attached_addresses)),
        userEdited : (status) => dispatch(userEdited(status)),
        addReportType : (url, postData) => dispatch(addReportType(url, postData))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportForm))



// WEBPACK FOOTER //
// ./src/views/Report/form.js